import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class EdgestateConnectionModel extends Model {
  @attr('string') name!: string;
  @attr('string') code!: string;
  @attr('string') edgestateAccountId!: string;

  @hasMany('edgestate-lockable', { async: false, inverse: null })
  edgestateLockables!: ModelRegistry['edgestate-lockable'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'edgestate-connection': EdgestateConnectionModel;
  }
}
